import React from "react";
import Grid from '@mui/material/Grid2';
const PolicyCard = (props) => {
    const { policy } = props;
    const getTag = () => {
        if(policy.policyStatus === 'Inforce'){
            return "/images/inforce.png"
        } else if(policy.policyStatus !== 'Inforce' && policy.savingType === 'Traditional'){
            return "/images/lapsed.png"
        }
        else if(policy.policyStatus !== 'Inforce' && policy.savingType === 'ULIP'){
            return "/images/discontinued.png"
        }
    }
    return (
        <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }} style={{backgroundColor:'#F5F5F5', paddingLeft:10, paddingRight:10, borderRadius:8}}>
            <Grid  spacing={2}>

                <img src={policy.logo} style={{ width: 90, height: 60, paddingTop: 10 }} />

            </Grid>
            <Grid spacing={2}>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', height: '100%', marginLeft:8 }}>

                    <span>{policy.policyHolderName}</span>


                    <span>{policy.policyNumber}</span>

                </div>
            </Grid>
            <Grid display={'inline-flex'} alignItems={'center'} size={2}>
                <div>
                    <img style={{ width: 82, height: 23 }} src={policy.savingType === 'Traditional' ? "/images/traditional.png" : "/images/ulip.png"} />

                </div>
                <div style={{marginLeft:'2px' }}>
                    <img style={{ minWidth: 82, maxWidth:130, height: 29 }} src={getTag()} />
                </div>
            </Grid>
        </Grid>
    )
}

export default PolicyCard